// @ts-nocheck
import React, { useEffect, useState } from "react";
import DashboardLayout from "../../components/layoutContainers/dashboardLayout";
import SoftBox from "../../components/common/softBox";
import {
  Card,
  FormControl,
  Select,
  MenuItem,
  Modal,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Table,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import SoftTypography from "../../components/common/softTypography";
import CustomTable from "../../components/tables/table";
import { FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import DashboardNavbar from "../../components/navbars/dashboardNavbar";
import { useAppDispatch, useAppSelector } from "../../Hooks";
import SoftBadge from "../../components/common/softBadge";
import {
  createReturnSalesOrderData,
  getReturnSalesOrderData,
  updateReturnSalesOrderData,
} from "../../features/returnSalesOrder";
import { toast } from "react-toastify";
import { prepareReturnOrderData } from "../../utils/commonHelper";
import SoftButton from "../../components/common/softButton";
import SoftInput from "../../components/common/softInput";
import ImageGallery from "react-image-gallery";
import ActionMenu from "../../components/common/custom/action-menu";
import {
  getSapOrderConfig,
  getSapPlantStorage,
} from "../../features/sapConfig";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
const ReturnSalesOrder = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [orderType, setOrderType] = useState("all");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [orderStatus, setOrderStatus] = useState("all");
  const [openModal, setOpenModal] = useState(false);
  const [openGallery, setOpenGallery] = useState(false);
  const [selectedOrderDetails, setSelectedOrderDetails] = useState({});

  const { data: orderData, status } = useAppSelector(
    (state: any) => state.returnSalesOrder
  );

  const { sapOrderConfigData, plantStorageData } = useAppSelector(
    (state: any) => state.sapConfig
  );
  const [totalRows, setTotalRows] = useState(0);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [salesOrg, setSalesOrg] = useState({
    value: "",
    label: "",
  });
  const [selectedSalesOrg, setSelectedSalesOrg] = useState("");
  const [distChannel, setDistChannel] = useState("");
  const [selectedDistChannel, setSelectedDistChannel] = useState("");
  const [division, setDivision] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");

  const [plant, setPlant] = useState({
    value: "",
    label: "",
  });
  const [ selectedPlant, setSelectedPlant] = useState("");

  // Removed storLoc and selectedStorLoc global state

  // Helper to get store locations for a given plant
  const getStoreLocOptions = (plantValue: string) => {
    if (!plantStorageData || !plantValue) return [];
    return Array.from(
      new Set(
        plantStorageData
          .filter((i) => i.Plant === plantValue)
          .map((i) => i.StorLoc)
      )
    ).map((dc) => ({ value: dc, label: dc }));
  };

  useEffect(() => {
    if (openModal) {
      dispatch(
        getSapOrderConfig({
          filter: `BusPartner eq '${selectedOrderDetails?.BusPartner}' and CompCode eq '${selectedOrderDetails?.CompanyCode}'`,
        })
      );
      dispatch(
        getSapPlantStorage({
          filter: `CompanyCode eq '${selectedOrderDetails?.CompanyCode}'`,
        })
      );
    }
  }, [dispatch, openModal]);

  useEffect(() => {
    if (sapOrderConfigData && sapOrderConfigData.length > 0) {
      setSelectedSalesOrg(sapOrderConfigData[0].SalesOrg);

      const distChannelTemp = Array.from(
        new Set(
          sapOrderConfigData
            .filter((i) => i.SalesOrg === sapOrderConfigData[0].SalesOrg)
            .map((i) => i.DistChannel)
        )
      ).map((dc) => ({ value: dc, label: dc }));
      setSelectedDistChannel(distChannelTemp[0].value);
      setDistChannel(distChannelTemp);

      const divisionTemp = Array.from(
        new Set(
          sapOrderConfigData
            .filter(
              (i) =>
                i.SalesOrg === sapOrderConfigData[0].SalesOrg &&
                i.DistChannel === distChannelTemp[0].value
            )
            .map((i) => ({ value: i.Division, label: i.Division }))
        )
      );
      setSelectedDivision(divisionTemp[0].value);
      setSelectedOrderDetails({
        ...selectedOrderDetails,
        Division: divisionTemp[0].value,
        SalesOrg: distChannelTemp[0].value,
        DistChannel: distChannelTemp[0].value,
      });

      setDivision(divisionTemp);

      const uniqueSalesOrgs = Array.from(
        new Set(sapOrderConfigData.map((item) => item.SalesOrg))
      );
      const options = uniqueSalesOrgs.map((org) => ({
        value: org,
        label: org,
      }));
      setSalesOrg(options);
    }
  }, [sapOrderConfigData]);

  useEffect(() => {
    if (plantStorageData && plantStorageData.length > 0) {
      setSelectedPlant(plantStorageData[0].Plant);

      const uniquePlant = Array.from(
        new Set(plantStorageData.map((item) => item.Plant))
      );
      const options = uniquePlant.map((org) => ({
        value: org,
        label: org,
      }));
      setPlant(options);
    }
  }, [plantStorageData]);

  useEffect(() => {
    if (!selectedSalesOrg) return;

    const distChannelTemp = Array.from(
      new Set(
        sapOrderConfigData
          .filter((i) => i.SalesOrg === selectedSalesOrg)
          .map((i) => i.DistChannel)
      )
    ).map((dc) => ({ value: dc, label: dc }));

    setDistChannel(distChannelTemp);
  }, [selectedSalesOrg, sapOrderConfigData]);

  useEffect(() => {
    if (selectedDistChannel) {
      const divisionTemp = Array.from(
        new Set(
          sapOrderConfigData
            .filter(
              (i) =>
                i.SalesOrg === selectedSalesOrg &&
                i.DistChannel === selectedDistChannel
            )
            .map((i) => ({ value: i.Division, label: i.Division }))
        )
      );
      setDivision(divisionTemp);
    }
  }, [selectedDistChannel]);

  const columns = [
    {
      header: "ID",
      accessorKey: "id",
      id: "id",
      align: "center",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Name",
      accessorKey: "user_id",
      id: "owner_name",
      align: "left",
      cell: (info: any) => <strong>{info.getValue()?.owner_name || ""}</strong>,
    },
    {
      header: "Business Partner",
      accessorKey: "BusPartner",
      id: "BusPartner",
      align: "left",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Sale Order No",
      accessorKey: "SalesOrder",
      id: "SalesOrder",
      align: "left",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Return Order No",
      accessorKey: "ReturnOrderNo",
      id: "ReturnOrderNo",
      align: "left",
      cell: (info: any) => <span>{info.getValue() || "N/A"}</span>,
    },
    {
      header: "Dist Channel",
      accessorKey: "DistChannel",
      id: "DistChannel",
      align: "left",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Division",
      accessorKey: "Division",
      id: "Division",
      align: "left",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Order Type",
      accessorKey: "OrderType",
      id: "OrderType",
      align: "left",
      cell: (info: any) => {
        const returnCode = info.row.original?.ReturnCode;
        const value = returnCode === "R08" ? "Expired" : "Return";
        return <span>{value}</span>;
      },
    },
    {
      header: "Return Order Reason",
      accessorKey: "ReturnOrderReason",
      id: "ReturnOrderReason",
      align: "left",
      cell: (info: any) => (
        <span style={{ textTransform: "capitalize" }}>
          {info.getValue() || "N/A"}
        </span>
      ),
    },
    {
      header: "Status",
      accessorKey: "status",
      id: "status",
      align: "left",
      cell: (info: any) => (
        <SoftBadge
          variant="gradient"
          style={{ textTransform: "capitalize", fontWeight: "500" }}
          badgeContent={info.getValue()}
          color={
            info.getValue() === "pending"
              ? "info"
              : info.getValue() === "reject"
              ? "error"
              : info.getValue() === "cancelled"
              ? "error"
              : info.getValue() === "ordered"
              ? "secondary"
              : "success"
          }
          size="xs"
          container
        />
      ),
    },
    {
      header: "Actions",
      id: "actions",
      align: "center",
      cell: (info: any) => {
        const id = info.row.original._id;
        const orderDetails = info.row.original;
        if (orderDetails.status === "cancelled") return null;
        return (
          <div>
            <ActionMenu sx={{ width: "50px" }}>
              <MenuItem
                onClick={() => {
                  setSelectedOrderDetails(orderDetails);
                  setOpenModal(true);
                }}
              >
                Add
              </MenuItem>
              <MenuItem
                onClick={() => {
                  navigate(`/return-sales-order/view/${id}`);
                }}
              >
                View
              </MenuItem>
            </ActionMenu>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    dispatch(
      getReturnSalesOrderData({
        page: pageIndex,
        limit: pageSize,
        status: orderType,
        order_type: orderStatus,
      })
    );
  }, [dispatch, pageIndex, pageSize, orderType, orderStatus]);

  useEffect(() => {
    // // // console.log({ orderData },'orderData');

    if (status && orderData) {
      setData(orderData?.orders);
      setTotalRows(orderData?.total || 0);
    }
  }, [status, orderData]);

  const onFilterChange = (e) => {
    if (e.target.name === "order_type") {
      setOrderStatus(e.target.value);
      setPageIndex(1);
      setPageSize(10);
      dispatch(
        getReturnSalesOrderData({
          page: 1,
          limit: 10,
          status: orderType,
          order_type: e.target.value,
        })
      );
    } else {
      setOrderType(e.target.value);
      setPageIndex(1);
      setPageSize(10);
      dispatch(
        getReturnSalesOrderData({
          page: 1,
          limit: 10,
          status: e.target.value,
          order_type: orderStatus,
        })
      );
    }
  };

  // // console.log(orderData, "orderData");

  const submitOrderToSap = (orderDetails: any) => {
    // // console.log(orderDetails,"orderDetails");
    setIsSubmitting(true);
    const finalData = prepareReturnOrderData(orderDetails);
    // // console.log(finalData,"finalData");
    // // console.log(orderDetails._id,"orderDetails");
    // return
    dispatch(
      createReturnSalesOrderData({ data: finalData, id: orderDetails?._id })
    ).then((res) => {
      // // // console.log({ res }, 'res');
      if (res && res.payload && res.payload.status) {
        setOpenModal(false);
        toast.success(res.payload.message);
        dispatch(
          getReturnSalesOrderData({
            page: pageIndex,
            limit: pageSize,
            status: orderType,
            order_type: orderStatus,
          })
        );
        // setIsSubmitting(false);
      }
    });
    setTimeout(() => {
      setIsSubmitting(false);
    }, 2000);
  };

  const handlereject = () => {
    dispatch(
      updateReturnSalesOrderData({
        id: selectedOrderDetails?._id,
        data: { status: "reject" },
      })
    ).then((res) => {
      // // // console.log({ res });
      if (res && res.payload && res.payload.status) {
        // setOpenModal(false);
        dispatch(
          getReturnSalesOrderData({
            page: pageIndex,
            limit: pageSize,
            status: orderType,
            order_type: orderStatus,
          })
        );
        // setUpdate(!update);
        toast.success(res.payload.message);
        setOpenModal(false);
      }
      // setOpenModal(false);
    });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card>
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          px={3}
          py={2}
        >
          <SoftBox>
            <SoftTypography variant="h4" fontWeight="bold" textAlign="left">
              Return Sales Order :
            </SoftTypography>
          </SoftBox>
          <SoftBox display="flex" gap="10px" alignItems="center">
            <SoftBox>
              <FormControl
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "row",
                  whiteSpace: "nowrap",
                  minWidth: "250px",
                }}
              >
                <SoftTypography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 500,
                    marginRight: "5px",
                  }}
                >
                  Order Type :
                </SoftTypography>
                <Select
                  id="demo-simple-select"
                  name="order_type"
                  value={orderStatus}
                  onChange={onFilterChange}
                  IconComponent={KeyboardArrowDownIcon}
                    fullWidth
                    size="small"
                    sx={{
                      padding: "0px 8px !important",
                      height: "40px !important",
                      display: "block !important",
                      ".MuiSelect-select": {
                        padding: "0px 8px !important",
                        height: "40px !important",
                      },
                      ".MuiSelect-nativeInput": {
                        height: "40px !important",
                      },
                      ".css-1e270hg-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                      ".css-8kuacp-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                    }}
                >
                  <MenuItem value={"all"} sx={{ marginBottom: "5px" }}>
                    All
                  </MenuItem>
                  <MenuItem value={"expire"} sx={{ marginBottom: "5px" }}>
                    Expire Order
                  </MenuItem>
                  <MenuItem value={"return_order"} sx={{ marginBottom: "5px" }}>
                    Return Order
                  </MenuItem>
                </Select>
              </FormControl>
            </SoftBox>
            <SoftBox>
              <FormControl
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "row",
                  whiteSpace: "nowrap",
                  minWidth: "250px",
                }}
              >
                <SoftTypography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 500,
                    marginRight: "5px",
                  }}
                >
                  Order Status
                </SoftTypography>
                <Select
                  id="demo-simple-select"
                  name="status"
                  value={orderType}
                  onChange={onFilterChange}
                  IconComponent={KeyboardArrowDownIcon}
                    fullWidth
                    size="small"
                    sx={{
                      padding: "0px 8px !important",
                      height: "40px !important",
                      display: "block !important",
                      ".MuiSelect-select": {
                        padding: "0px 8px !important",
                        height: "40px !important",
                      },
                      ".MuiSelect-nativeInput": {
                        height: "40px !important",
                      },
                      ".css-1e270hg-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                      ".css-8kuacp-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                    }}
                >
                  <MenuItem value={"all"} sx={{ marginBottom: "5px" }}>
                    All
                  </MenuItem>
                  <MenuItem value={"pending"} sx={{ marginBottom: "5px" }}>
                    Pending
                  </MenuItem>
                  <MenuItem value={"approve"} sx={{ marginBottom: "5px" }}>
                    Approved
                  </MenuItem>
                  <MenuItem value={"ordered"} sx={{ marginBottom: "5px" }}>
                    Ordered
                  </MenuItem>
                  <MenuItem value={"cancelled"} sx={{ marginBottom: "5px" }}>
                    Cancelled
                  </MenuItem>
                  <MenuItem value={"reject"} sx={{ marginBottom: "5px" }}>
                    Reject
                  </MenuItem>
                </Select>
              </FormControl>
            </SoftBox>
          </SoftBox>
        </SoftBox>

        <CustomTable
          columns={columns}
          data={data}
          pageIndex={pageIndex}
          pageSize={pageSize}
          totalRows={totalRows}
          onPageChange={(newPageIndex) => setPageIndex(newPageIndex)}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        />
      </Card>

      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle
          id="modal-modal-title"
          sx={{ fontSize: "18px", fontWeight: "700", lineHeight: "normal" }}
        >
          Post Return Order Request to SAP
        </DialogTitle>

        <DialogContent dividers>
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
            pb={1}
          >
            <SoftBox
              sx={{
                display: "flex",
                alignItems: "center",
                paddingBottom: "10px",
                marginBottom: "0px",
                borderBottom: "1px solid #ccc",
                borderRadius: "0px",
                width: {
                  sm: "100%",
                  md: "48%",
                },
              }}
            >
              <SoftTypography
                variant="button"
                fontWeight="bold"
                textTransform="capitalize"
              >
                Business Partner No: &nbsp;
              </SoftTypography>
              <SoftTypography
                variant="button"
                fontWeight="regular"
                color="text"
              >
                &nbsp;{selectedOrderDetails?.BusPartner || "N/A"}
              </SoftTypography>
            </SoftBox>
            <SoftBox
              sx={{
                display: "flex",
                alignItems: "center",
                paddingBottom: "10px",
                marginBottom: "0px",
                borderBottom: "1px solid #ccc",
                borderRadius: "0px",
                width: {
                  sm: "100%",
                  md: "48%",
                },
              }}
            >
              <SoftTypography
                variant="button"
                tag="h3"
                fontWeight="bold"
                textTransform="capitalize"
              >
                Name: &nbsp;
              </SoftTypography>
              <SoftTypography
                variant="button"
                fontWeight="regular"
                color="text"
              >
                &nbsp;{selectedOrderDetails?.user_id?.owner_name || "N/A"}
              </SoftTypography>
            </SoftBox>
          </SoftBox>
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
            pb={1}
          >
            <SoftBox
              sx={{
                display: "flex",
                alignItems: "center",
                paddingBottom: "10px",
                marginBottom: "0px",
                borderBottom: "1px solid #ccc",
                borderRadius: "0px",
                width: {
                  sm: "100%",
                  md: "48%",
                },
              }}
            >
              <SoftTypography
                variant="button"
                fontWeight="bold"
                textTransform="capitalize"
              >
                Return Order Reason: &nbsp;
              </SoftTypography>
              <SoftTypography
                variant="button"
                fontWeight="regular"
                color="text"
                textTransform="capitalize"
              >
                &nbsp;{selectedOrderDetails?.ReturnOrderReason || "N/A"}
              </SoftTypography>
            </SoftBox>
          </SoftBox>
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
            pb={1}
          >
            <SoftBox
              sx={{
                display: "flex",
                alignItems: "center",
                paddingBottom: "10px",
                marginBottom: "0px",
                borderBottom: "1px solid #ccc",
                borderRadius: "0px",
                width: {
                  sm: "100%",
                  md: "48%",
                },
              }}
            >
              <SoftTypography
                variant="button"
                fontWeight="bold"
                textTransform="capitalize"
              >
                Status: &nbsp;
              </SoftTypography>
              <SoftBadge
                variant="gradient"
                badgeContent={selectedOrderDetails?.status}
                color={
                  selectedOrderDetails?.status === "pending"
                    ? "info"
                    : selectedOrderDetails?.status === "reject"
                    ? "error"
                    : selectedOrderDetails?.status === "cancelled"
                    ? "error"
                    : "success"
                }
                size="xs"
                container
              />
            </SoftBox>
            <SoftBox
              sx={{
                display: "flex",
                alignItems: "center",
                paddingBottom: "10px",
                marginBottom: "0px",
                borderBottom: "1px solid #ccc",
                borderRadius: "0px",
                width: {
                  sm: "100%",
                  md: "48%",
                },
              }}
            >
              <SoftTypography
                variant="button"
                fontWeight="bold"
                textTransform="capitalize"
              >
                Sales Order: &nbsp;
              </SoftTypography>
              <SoftTypography
                variant="button"
                fontWeight="regular"
                color="text"
              >
                &nbsp;{selectedOrderDetails?.SalesOrder || "N/A"}
              </SoftTypography>
            </SoftBox>
          </SoftBox>

          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
            pb={1}
          >
            <SoftBox
              sx={{
                display: "flex",
                alignItems: "center",
                paddingBottom: "10px",
                marginBottom: "0px",
                borderBottom: "1px solid #ccc",
                borderRadius: "0px",
                width: {
                  sm: "100%",
                  md: "48%",
                },
              }}
            >
              <SoftTypography
                variant="button"
                fontWeight="bold"
                textTransform="capitalize"
              >
                Return Reason: &nbsp;
              </SoftTypography>
              <SoftTypography
                variant="button"
                fontWeight="regular"
                color="text"
              >
                &nbsp;{selectedOrderDetails?.ReturnReason || "N/A"}
              </SoftTypography>
            </SoftBox>
            <SoftBox
              sx={{
                display: "flex",
                alignItems: "center",
                paddingBottom: "10px",
                marginBottom: "0px",
                borderBottom: "1px solid #ccc",
                borderRadius: "0px",
                width: {
                  sm: "100%",
                  md: "48%",
                },
              }}
            >
              <SoftTypography
                variant="button"
                fontWeight="bold"
                textTransform="capitalize"
              >
                Req Date: &nbsp;
              </SoftTypography>
              <SoftTypography
                variant="button"
                fontWeight="regular"
                color="text"
              >
                &nbsp;
                {new Date(selectedOrderDetails?.ReqDate).toLocaleDateString(
                  "en-GB"
                )}
              </SoftTypography>
            </SoftBox>
          </SoftBox>
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
            pb={1}
          >
            <SoftBox
              sx={{
                display: "flex",
                alignItems: "center",
                paddingBottom: "10px",
                marginBottom: "0px",
                borderBottom: "1px solid #ccc",
                borderRadius: "0px",
                width: {
                  sm: "100%",
                  md: "48%",
                },
              }}
            >
              <SoftTypography
                variant="button"
                fontWeight="bold"
                textTransform="capitalize"
              >
                Return Code: &nbsp;
              </SoftTypography>
              <SoftTypography
                variant="button"
                fontWeight="regular"
                color="text"
              >
                &nbsp;{selectedOrderDetails?.ReturnCode || "N/A"}
              </SoftTypography>
            </SoftBox>
            <SoftBox
              sx={{
                display: "flex",
                alignItems: "center",
                paddingBottom: "10px",
                marginBottom: "0px",
                borderBottom: "1px solid #ccc",
                borderRadius: "0px",
                width: {
                  sm: "100%",
                  md: "48%",
                },
              }}
            >
              <SoftTypography
                variant="button"
                fontWeight="bold"
                textTransform="capitalize"
              >
                Return Date: &nbsp;
              </SoftTypography>
              <SoftTypography
                variant="button"
                fontWeight="regular"
                color="text"
              >
                &nbsp;
                {new Date(selectedOrderDetails?.ReturnDate).toLocaleDateString(
                  "en-GB"
                )}
              </SoftTypography>
            </SoftBox>
          </SoftBox>
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
            pb={1}
          >
            <SoftBox
              sx={{
                width: {
                  sm: "100%",
                  md: "48%",
                },
              }}
            >
              <SoftTypography
                variant="button"
                fontWeight="bold"
                textTransform="capitalize"
              >
                Division: &nbsp;
              </SoftTypography>
              <Select
                value={selectedDivision}
                onChange={(e) => {
                  setSelectedDivision(e.target.value);
                  setSelectedOrderDetails({
                    ...selectedOrderDetails,
                    Division: e.target.value,
                  });
                }}
                id="demo-simple-select"
                name="division"
                IconComponent={KeyboardArrowDownIcon}
                    fullWidth
                    size="small"
                    sx={{
                      padding: "0px 8px !important",
                      height: "40px !important",
                      display: "block !important",
                      ".MuiSelect-select": {
                        padding: "0px 8px !important",
                        height: "40px !important",
                      },
                      ".MuiSelect-nativeInput": {
                        height: "40px !important",
                      },
                      ".css-1e270hg-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                      ".css-8kuacp-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                    }}
              >
                {division &&
                  division.map((item: any, index: number) => (
                    <MenuItem value={item.value}>{item.label}</MenuItem>
                  ))}
              </Select>
            </SoftBox>
            <SoftBox
              sx={{
                width: {
                  sm: "100%",
                  md: "48%",
                },
              }}
            >
              <SoftTypography
                variant="button"
                fontWeight="bold"
                textTransform="capitalize"
              >
                Dist. Channel: &nbsp;
              </SoftTypography>
              <Select
                value={selectedDistChannel}
                onChange={(e) => {
                  setSelectedDistChannel(e.target.value);
                  setSelectedOrderDetails({
                    ...selectedOrderDetails,
                    DistChannel: e.target.value,
                  });
                }}
                id="demo-simple-select"
                name="distChannel"
                IconComponent={KeyboardArrowDownIcon}
                    fullWidth
                    size="small"
                    sx={{
                      padding: "0px 8px !important",
                      height: "40px !important",
                      display: "block !important",
                      ".MuiSelect-select": {
                        padding: "0px 8px !important",
                        height: "40px !important",
                      },
                      ".MuiSelect-nativeInput": {
                        height: "40px !important",
                      },
                      ".css-1e270hg-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                      ".css-8kuacp-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                    }}
              >
                {distChannel &&
                  distChannel.map((item: any, index: number) => (
                    <MenuItem value={item.value}>{item.label}</MenuItem>
                  ))}
              </Select>
            </SoftBox>
          </SoftBox>
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
            pb={1}
          >
            <SoftBox
              sx={{
                width: {
                  sm: "100%",
                  md: "48%",
                },
              }}
            >
              <SoftTypography
                variant="button"
                fontWeight="bold"
                textTransform="capitalize"
              >
                Sale Organization: &nbsp;
              </SoftTypography>
              <Select
                id="demo-simple-select"
                name="SalesOrg"
                value={selectedSalesOrg}
                onChange={(e) => {
                  setSelectedSalesOrg(e.target.value);
                  setSelectedOrderDetails({
                    ...selectedOrderDetails,
                    SalesOrg: e.target.value,
                  });
                }}
                IconComponent={KeyboardArrowDownIcon}
                    fullWidth
                    size="small"
                    sx={{
                      padding: "0px 8px !important",
                      height: "40px !important",
                      display: "block !important",
                      ".MuiSelect-select": {
                        padding: "0px 8px !important",
                        height: "40px !important",
                      },
                      ".MuiSelect-nativeInput": {
                        height: "40px !important",
                      },
                      ".css-1e270hg-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                      ".css-8kuacp-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                    }}
              >
                {salesOrg &&
                  salesOrg.length > 0 &&
                  salesOrg.map((item: any) => {
                    return <MenuItem value={item.value}>{item.label}</MenuItem>;
                  })}
              </Select>
            </SoftBox>
            <SoftBox
              sx={{
                width: {
                  sm: "100%",
                  md: "48%",
                },
              }}
            >
              <SoftTypography
                variant="button"
                fontWeight="bold"
                textTransform="capitalize"
              >
                Doc Type: &nbsp;
              </SoftTypography>
              <SoftTypography
                variant="button"
                fontWeight="regular"
                color="text"
              >
                <SoftInput
                  value={selectedOrderDetails?.DocType || "N/A"}
                  onChange={(e) =>
                    setSelectedOrderDetails({
                      ...selectedOrderDetails,
                      DocType: e.target.value,
                    })
                  }
                />
              </SoftTypography>
            </SoftBox>
          </SoftBox>
          <SoftBox pb={2}>
            {selectedOrderDetails?.image_urls &&
              selectedOrderDetails?.image_urls.length > 0 && (
                <SoftBox display="inline-flex">
                  <SoftTypography
                    variant="button"
                    fontWeight="bold"
                    textTransform="capitalize"
                  >
                    Images: &nbsp;
                  </SoftTypography>
                  <SoftTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                  >
                    <FaEye
                      style={{
                        cursor: "pointer",
                        height: "25px",
                        width: "25px",
                        color: "#1b3648",
                        padding: "3px",
                        border: "1px solid #1b3648",
                        borderRadius: "5px",
                      }}
                      onClick={() => setOpenGallery(true)}
                      mt={1}
                    />
                  </SoftTypography>
                </SoftBox>
              )}
          </SoftBox>
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
            pb={2}
          >
            {/* <SoftTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Material Details: &nbsp;
            </SoftTypography> */}

            <TableContainer
              className="table-container"
              sx={{ padding: "0px", borderRadius: "0px" }}
            >
              <Table
                sx={{ Width: "100%" }}
                className="w3-table-all"
                aria-label="Order Material List table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell>Batch</TableCell>
                    <TableCell>Item No</TableCell>
                    <TableCell>Material</TableCell>
                    <TableCell>NetValue</TableCell>
                    <TableCell>Qty</TableCell>
                    <TableCell>Plant</TableCell>
                    <TableCell>Req Date</TableCell>
                    <TableCell>Sales Order</TableCell>
                    <TableCell>Store Loc</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {selectedOrderDetails &&
                  selectedOrderDetails?.NavHeaderToItem &&
                  selectedOrderDetails?.NavHeaderToItem.length > 0 ? (
                    selectedOrderDetails?.NavHeaderToItem.map(
                      (item: any, index: number) => (
                        <>
                          <TableRow key={"order-item-" + index}>
                            <TableCell>{item.Batch}</TableCell>
                            <TableCell>{item.ItemNo}</TableCell>
                            <TableCell>{item.Material}</TableCell>
                            <TableCell>{item.NetValue}</TableCell>
                            <TableCell>
                              <SoftInput
                                value={item.OrderQty}
                                onChange={(e) =>
                                  setSelectedOrderDetails({
                                    ...selectedOrderDetails,
                                    NavHeaderToItem:
                                      selectedOrderDetails?.NavHeaderToItem.map(
                                        (item: any, i: number) =>
                                          index === i
                                            ? {
                                                ...item,
                                                OrderQty: e.target.value,
                                              }
                                            : item
                                      ),
                                  })
                                }
                              />
                            </TableCell>
                            <TableCell>
                              <Select
                                value={item.Plant || ""}
                                onChange={(e) => {
                                  setSelectedOrderDetails({
                                    ...selectedOrderDetails,
                                    NavHeaderToItem:
                                      selectedOrderDetails?.NavHeaderToItem.map(
                                        (itm: any, i: number) =>
                                          index === i
                                            ? {
                                                ...itm,
                                                Plant: e.target.value,
                                                StoreLoc: "", // reset StoreLoc when Plant changes
                                              }
                                            : itm
                                      ),
                                  });
                                }}
                                id="demo-simple-select"
                                name="Plant"
                                style={{ width: "100%" }}
                              >
                                {plant &&
                                  plant.length > 0 &&
                                  plant.map((p: any) => (
                                    <MenuItem key={p.value} value={p.value}>
                                      {p.label}
                                    </MenuItem>
                                  ))}
                              </Select>
                            </TableCell>
                            <TableCell>
                              {item.ReqDate
                                ? new Date(item.ReqDate).toLocaleDateString(
                                    "en-GB"
                                  )
                                : "N/A"}
                            </TableCell>
                            <TableCell>{item.SalesOrder}</TableCell>
                            <TableCell>
                              <Select
                                value={item.StoreLoc || ""}
                                onChange={(e) => {
                                  setSelectedOrderDetails({
                                    ...selectedOrderDetails,
                                    NavHeaderToItem:
                                      selectedOrderDetails?.NavHeaderToItem.map(
                                        (itm: any, i: number) =>
                                          index === i
                                            ? {
                                                ...itm,
                                                StoreLoc: e.target.value,
                                              }
                                            : itm
                                      ),
                                  });
                                }}
                                id="demo-simple-select"
                                name="storLoc"
                                style={{ width: "100%" }}
                              >
                                {getStoreLocOptions(item.Plant).map((opt) => (
                                  <MenuItem key={opt.value} value={opt.value}>
                                    {opt.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </TableCell>
                          </TableRow>
                        </>
                      )
                    )
                  ) : (
                    <TableRow>
                      <TableCell colSpan={9} align="center">
                        No material details available.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </SoftBox>
          <SoftBox pb={2} pr={2}>
            {selectedOrderDetails?.ReturnOrderNo && (
              <p style={{ fontSize: 16, marginRight: "14px" }}>
                Your Return Order is Submited to Sap. Return Sales Order No:{" "}
                {selectedOrderDetails?.ReturnOrderNo}
              </p>
            )}
          </SoftBox>
          <SoftBox
            display={"flex"}
            alignItems={"center"}
            justifyContent="end"
            gap={1}
          >
            <SoftButton
              className="modal_cancel modal_btn"
              onClick={handlereject}
              disabled={selectedOrderDetails?.status !== "pending"}
            >
              Reject
            </SoftButton>
            <SoftButton
              className="modal_btn"
              disabled={
                selectedOrderDetails?.ReturnOrderNo ||
                selectedOrderDetails?.status !== "pending" ||
                isSubmitting
              }
              onClick={() => submitOrderToSap(selectedOrderDetails)}
            >
              {isSubmitting ? "Sending..." : "Send To SAP"}
            </SoftButton>
          </SoftBox>
        </DialogContent>
      </Dialog>
      <Modal open={openGallery} onClose={() => setOpenGallery(false)}>
        <SoftBox
          bgColor="white"
          p={2}
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            outline: "none",
            maxWidth: "90vw",
            maxHeight: "90vh",
            overflow: "auto",
          }}
        >
          {selectedOrderDetails?.image_urls &&
            selectedOrderDetails?.image_urls.length > 0 && (
              <ImageGallery
                items={selectedOrderDetails?.image_urls.map((image) => ({
                  original: image,
                  thumbnail: image,
                }))}
                showThumbnails={true}
                showPlayButton={false}
                showFullscreenButton={true}
              />
            )}
        </SoftBox>
      </Modal>
    </DashboardLayout>
  );
};

export default ReturnSalesOrder;
